import {
  AssetData,
  BlokToComponentProps,
  rocheVideoPlayerTracking,
  StoryblokService,
  TrackedPercentage,
  useConfig,
  useTranslation,
} from '@repo/roche-xx-shared';
import { RocheUIVideoPlayer } from '@rocheglobal/roche-ui';
import React, { FC, useRef } from 'react';

type RocheUIVideoPlayerProps = BlokToComponentProps<{
  preview: AssetData;
  brightcove_video?: string;
  youtube_video?: string;
  caption?: string;
  copyright?: string;
  fullscreen?: boolean;
}>;

export const RocheVideoPlayer: FC<RocheUIVideoPlayerProps> = ({ blok, slot }): JSX.Element => {
  const awsVideoId = blok.brightcove_video;
  const youtubeVideoId = blok.youtube_video;
  const caption = blok.caption;
  const copyright = blok.copyright;
  const videoId = awsVideoId || youtubeVideoId;
  const fullscreen = blok.fullscreen;
  const playLabel = useTranslation('play');
  const pauseLabel = useTranslation('pause');
  const trackedVideoPercentages = useRef<TrackedPercentage>({});
  const service = awsVideoId ? 'aws' : 'youtube';
  const { GATSBY_AWS_VIDEO_SERVICE_BASE_URL } = useConfig();

  // We should not try poor this state into the RocheUIVideoPlayer, custom inline component:
  if (!videoId && StoryblokService.isInEditor()) {
    return (
      <div
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '2.39 / 1',
          backgroundColor: '#FF1F26',
          padding: '20px',
        }}
      >
        <p>Warning! You must provide either a Video ID or a Youtube Video before publishing.</p>
      </div>
    );
  }

  return (
    <RocheUIVideoPlayer
      awsServiceBaseUrl={GATSBY_AWS_VIDEO_SERVICE_BASE_URL}
      service={service}
      videoId={videoId}
      caption={caption}
      copyright={copyright}
      preview={blok.preview.filename}
      previewAlt={blok.preview.alt}
      fullscreen={fullscreen}
      playLabel={playLabel}
      pauseLabel={pauseLabel}
      slot={slot}
      onVideoStateChange={(event) => rocheVideoPlayerTracking(event, trackedVideoPercentages, false)}
    />
  );
};
